import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Close32 from "@carbon/icons-react/lib/close/32";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { IconButton, PrimaryButton } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";
import { ReactComponent as CoinTossIcon } from "../../../assets/images/coin-toss.svg";
import { useFootballContext } from "../../../state/football-play/context";
import commonStyles from "../../common/styles/Common.styles";
import GameConfig from "../components/GameConfig";
import SubmitCancelListener from "../components/listeners/SubmitCancelListener";
import { GameRoutes } from "../../../routes/game-routes";
import { useAppContext } from "../../../state/app/context";
import { useEventContext } from "../../../state/events/context";

const GameConfigContainer = () => {
	const commonClasses = commonStyles();

	const { startGame } = useFootballContext();
	const { state: appState, redirect } = useAppContext();
	const isSubmitting = appState.isSubmitting();
	const { state: eventState } = useEventContext();

	const currentEvent = eventState.currentEvent();

	const [showSettingsDialog, setShowSettingsDialog] = useState(false);
	const [settings, setSettings] = useState();

	const start = () => {
		startGame(settings);
	};

	const isValid = () => {
		return (
			settings && settings.tossWinner && settings.offenseTeam && !isSubmitting
		);
	};

	const handleOnSubmit = () => {
		if (showSettingsDialog) start();
		else setShowSettingsDialog(true);
	};

	const handleChangeSettings = () => {
		redirect(
			`${GameRoutes.EVENT_INFORMATION.url.replace(
				":eventId",
				currentEvent.id
			)}#settings`
		);
	};

	return (
		<>
			<SubmitCancelListener
				enableOnTags={showSettingsDialog && ["input"]}
				submitDisabled={showSettingsDialog && !isValid()}
				onSubmit={handleOnSubmit}
			/>
			<Grid
				container
				align="center"
				alignItems="center"
				className={commonClasses.container}
			>
				<Grid item xs={12}>
					<CoinTossIcon />
					<Typography variant="h3">This game will start soon</Typography>
					<Typography variant="body1">
						Select the settings to begin the game
					</Typography>
					<Box mt={4} />
					<PrimaryButton
						id="setup-game-button"
						label="Setup game"
						onClick={() => setShowSettingsDialog(true)}
						size="medium"
					/>
				</Grid>
			</Grid>

			<Dialog
				open={showSettingsDialog}
				aria-labelledby="alert-dialog-title"
				fullWidth
				onClose={() => setShowSettingsDialog(false)}
			>
				<DialogTitle id="alert-dialog-title">
					<IconButton
						onClick={() => setShowSettingsDialog(false)}
						aria-label="close-dialog"
						className={commonClasses.closeButton}
					>
						<Close32 />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					<GameConfig
						onChange={setSettings}
						title="Game Start"
						subtitle="Select the settings to begin the game"
					/>
				</DialogContent>
				<DialogActions>
					<Button
						id="edit-settings-button"
						onClick={handleChangeSettings}
						color="secondary"
					>
						Change Settings
					</Button>
					<Button
						id="start-game-button"
						onClick={start}
						color="primary"
						disabled={!isValid()}
					>
						Start Game
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
export default GameConfigContainer;
